export default function CompetenciesCard({ competencies = [] }) {
  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>Competencies</h3>
          <span className="sub">Self-assessed</span>
        </div>
      </div>
      <div className="rtv2-comp-list">
        {competencies.map((c) => {
          const fill = Math.max(0, Math.min(10, Math.round(c.value)));
          return (
            <div key={c.key} className="rtv2-comp-item">
              <div className="lbl">{c.key}</div>
              <div className="dots">
                {Array.from({ length: 10 }).map((_, i) => <i key={i} className={i < fill ? "on" : ""} />)}
              </div>
              <div className="score">{c.value.toFixed(1)}/10</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
